function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  transform: "matrix(0 -1 -1 0 24 24)",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M7.12302 13.1161C6.9603 13.2789 6.9603 13.5427 7.12302 13.7054L7.71227 14.2946C7.87499 14.4574 8.13881 14.4574 8.30153 14.2946L12 10.5961L15.6986 14.2946C15.8613 14.4574 16.1251 14.4574 16.2878 14.2946L16.8771 13.7054C17.0398 13.5427 17.0398 13.2789 16.8771 13.1161L12.2956 8.53467C12.2139 8.45294 12.1066 8.41226 11.9995 8.41264C11.8927 8.41254 11.7859 8.45322 11.7045 8.53467L7.12302 13.1161Z",
  fill: "white"
});

var SvgChevronUpInCircleFill = function SvgChevronUpInCircleFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronUpInCircleFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-up-in-circle-fill.d7520291.svg";
export { ForwardRef as ReactComponent };